import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, Switch } from 'react-router-dom';

import { restoreLogin } from '../../redux/actions/RestoreLogin';

import Login from '../Login';
import CheckCode from '../CheckCode';
import ProfilesList from '../ProfileList/ProfilesList';

import * as URLs from '../../../../common/constants/systemUrls';

import '../../../../common/css/login_register.css';
import EditProfile from '../EditProfile/EditProfile';
import AddProfileContainer from '../AddProfile/AddProfileContainer';

class Authorization extends Component {
  state = {};

  render() {
    const { loginStatus } = this.props;
    return (
      <Switch>
        <Route exact path={'/'} render={props => <Login {...props} />} />
        <Route
          exact
          path={'/' + URLs.AUTHORIZATION + '/' + URLs.LOGIN}
          render={props => <Login {...props} />}
        />
        <Route
          exact
          path={'/' + URLs.AUTHORIZATION + '/' + URLs.CHECK_CODE}
          render={props => <CheckCode {...props} />}
        />
        {loginStatus.message === 'SUCCESS' && (
          <Route
            exact
            path={'/' + URLs.AUTHORIZATION + '/' + URLs.PROFILES_LIST}
            render={props => <ProfilesList {...props} />}
          />
        )}
        {loginStatus.message === 'SUCCESS' && (
          <Route
            exact
            path={'/' + URLs.AUTHORIZATION + '/' + URLs.ADD_PROFILE}
            render={props => <AddProfileContainer {...props} />}
          />
        )}
        {loginStatus.message === 'SUCCESS' && (
          <Route
            exact
            path={
              '/' + URLs.AUTHORIZATION + '/' + URLs.EDIT_PROFILE + '/:clientId'
            }
            render={props => <EditProfile {...props} />}
          />
        )}
        {loginStatus.message !== 'SUCCESS' && (
          <Redirect to="/authorization/login" />
        )}
      </Switch>
    );
  }
}

export default connect(
  state => ({
    loginStatus: state.Authorization.status.loginStatus,
  }),
  {
    restoreLogin,
  }
)(Authorization);
